import { WidgetUploadError } from './upload-thread-file.js';
import { isNetworkError } from './is-network-error.js';

/** Errors where the outbound queue should keep the entry and retry later. */
export function isRetryableQueueError(error: unknown): boolean {
  if (isNetworkError(error)) return true;
  if (error instanceof WidgetUploadError && error.code === 'NO_THREAD') {
    return true;
  }
  return false;
}
